import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch} from 'vue';
type Props = {
	modelValue: boolean
	disabled?: boolean
	loading?: boolean
	id?: string
	label?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'checkbox',
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    id: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;
const isChecked = ref(false);
const isDisabled = ref(false);

onMounted(() => {
	isChecked.value = props.modelValue;
	isDisabled.value = !!props.disabled;
});

watch(()=>props.modelValue,() => {
	if(props.modelValue){
		isChecked.value = true;
	}else{
		isChecked.value = false;
	}
    
	if(props.disabled) {
		isDisabled.value = true;
	}
});

watch(()=>props.disabled,() => {
	if(props.disabled) {
		isDisabled.value = true;
	}else{
		isDisabled.value = false;
	}
});

function handleLabelClick(){
	if(isDisabled.value || props.loading) return;

	updateValue(!isChecked.value);
}

function updateValue(value: boolean){
	if(!isDisabled.value){
		isChecked.value = value;
		emit('update:modelValue', value);
	}
}

const __returned__ = { props, emit, isChecked, isDisabled, handleLabelClick, updateValue, ref, onMounted, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})